import { render, staticRenderFns } from "./InformationConfiguration.vue?vue&type=template&id=9f80728a&scoped=true"
import script from "./InformationConfiguration.vue?vue&type=script&lang=js"
export * from "./InformationConfiguration.vue?vue&type=script&lang=js"
import style0 from "./InformationConfiguration.vue?vue&type=style&index=0&id=9f80728a&prod&scoped=true&lang=css"
import style1 from "./InformationConfiguration.vue?vue&type=style&index=1&id=9f80728a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f80728a",
  null
  
)

export default component.exports